module.exports = __webpack_public_path__ + "img/Kingsley Wong.5ac5f5ca.jpg";